<div class="widget-container m-a">
  @switch (widget.type) {
    @case (DashboardWidgetType.LANDLORD_ADD_PROPERTIES) {
      <cp-widget-add-landlord-properties />
    }
    @case (DashboardWidgetType.MORTGAGE_EXPIRATION) {
      <cp-widget-remortgage-guide
        [propertyId]="widget?.property?.id"
        [remainingMonths]="widget.mortgage?.numberOfMonthsToLastEarlyRepaymentChargeEndDate"
        [expirationStatus]="widget.mortgage?.mortgageExpiryType"
        [isCompanyBranded]="widget.isCompanyBranded" />
    }
    @case (DashboardWidgetType.MORTGAGE_WITH_NO_CASE_AND_DATA_FILLED) {
      <cp-widget-best-deal [isCompanyBranded]="widget.isCompanyBranded" />
    }
    @case (DashboardWidgetType.HAS_ACTIVE_CASE) {
      <cp-widget-has-case
        [mortgageId]="widget.mortgage?.id"
        [isCompanyBranded]="widget.isCompanyBranded" />
    }
    @case (DashboardWidgetType.HAS_DEAL) {
      <cp-widget-better-deal [widget]="widget" />
    }
    @case (DashboardWidgetType.EPC_IMPROVEMENTS) {
      <cp-widget-epc-improvements
        [epc]="widget.property.energyPerformanceCertificate"
        [propertyId]="widget.property.id"
        [propertyName]="widget.property.name" />
    }
    @case (DashboardWidgetType.ADD_SMART_SEARCH) {
      <cp-widget-add-smart-search />
    }
    @case (DashboardWidgetType.MORTGAGE_WITH_NO_CASE_AND_MINIMAL_DATA) {
      <cp-widget-minimal-data />
    }
    @case (DashboardWidgetType.ADD_PROPERTY) {
      <cp-widget-add-property />
    }
  }
</div>
